module.exports = __webpack_public_path__ + "static/media/response-card.816ad0bf.svg";